<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>
<script>
	import 'bootstrap/dist/css/bootstrap.min.css';
	import 'bootstrap/dist/js/bootstrap.min.js';
	
	export default {
		name: 'App',
		data() {
			return {}
		},
	}
</script>
<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
	body,
	div,
	h3,
	button,
	.row,
	.container,
	.col-1,
	.col-2,
	.col-3,
	.col-4,
	.col-6,
	.col-8,img{
		padding: 0px;
		border: 0px;
		margin: 0px;
	}
</style>
